<template>
  <div>
    <b-card no-body v-for="issue in issues" :key="issue.id" class="mb-1">
      <template v-if="issue.ignored">
        <b-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span
                v-html="issue.title(issue.assets.length)"
                class="text-muted"
              />
            </div>
            <div class="text-small">
              <b-link @click="toggleIgnore(issue)" class="text-muted"
                >Un-mute</b-link
              >
            </div>
          </div>
        </b-card-header>
      </template>
      <template v-else>
        <b-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <strong
                ><span v-html="issue.title(issue.assets.length)"
              /></strong>
              <b-icon-info-circle
                v-if="issue.tooltip && issue.tooltip()"
                v-b-tooltip="issue.tooltip()"
                class="ml-1 text-small"
              />
            </div>
            <div class="text-small" v-if="issue.ignorable">
              <b-link @click="toggleIgnore(issue)" class="text-muted"
                >Mute</b-link
              >
            </div>
          </div>
        </b-card-header>
        <b-card-body>
          {{ issue.description }}
          <b-link 
            v-if="!issue.is_expanded"
            v-b-toggle="`accordion-${issue.id}`" 
            class="ml-1 text-nowrap"
            >Details
            <b-icon-chevron-down class="when-closed" /><b-icon-chevron-up
              class="when-open"
          /></b-link>
        </b-card-body>
        <b-collapse
          :visible="issue.is_expanded"
          :id="`accordion-${issue.id}`"
          :accordion="issue.is_expanded ? null : 'issues-accordion'"
          role="tabpanel"
        >
          <b-list-group flush>
            <b-list-group-item
              v-for="(asset, i) of issue.assets.slice(0, 4)"
              :key="asset.url"
            >
              <div
                v-if="i == 0 && issue.field"
                class="d-flex justify-content-between align-items-center mb-3"
              >
                <div class="text-small text-muted">URL</div>
                <div class="text-small text-muted">
                  {{ issue.field.label }}
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-small">
                  <a
                    :href="asset.url"
                    :title="asset.url"
                    target="_blank"
                    class="text-break text-muted text-small"
                  >
                    <span class="page_url mr-1">{{
                      asset.url | truncate(90)
                    }}</span>
                    <b-icon-box-arrow-up-right class="mr-2" />
                  </a>
                </div>
                <div class="text-small" v-if="issue.field">
                  {{ asset[issue.field.key] | formatNumber }}
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item v-if="issue.assets.length > 4">
              <div class="text-small text-muted">
                ... and {{ issue.assets.length - 4 }} more
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-collapse>
      </template>
    </b-card>
  </div>
</template>
<style scoped>
.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
</style>
<script>
import _ from 'lodash'

export default {
  name: 'AssetIssues',
  components: {},
  props: ['page', 'asset_issues', 'expanded'],

  data: () => {
    return {}
  },

  computed: {
    issues() {
      const content = {
        error: {
          title: (n) => `${n} Broken Asset${n != 1 ? 's' : ''}`,
          description: `Broken images/styles/scripts can cause rendering issues and slowness.`,
          ignorable: true,
          field: {
            label: 'Status Code',
            key: 'status_code'
          }
        },
        large: {
          title: (n) => `${n} Large File${n != 1 ? 's' : ''}`,
          description: `Reduce the size of these files to increase page speed.`,
          ignorable: true,
          field: {
            label: 'File size',
            key: 'content_length'
          }
        },
        slow: {
          title: (n) => `${n} Slow Response Time${n != 1 ? 's' : ''}`,
          description: `Investigate why the server response time might be slowing down the page.`,
          ignorable: true,
          field: {
            label: 'Response time',
            key: 'response_time'
          }
        },
        cdn: {
          title: (n) => `${n} File${n != 1 ? 's' : ''} not on a CDN`,
          description: `A Content Delivery Network (CDN) can drastically improves page speed.`,
          ignorable: true
        },
        cache: {
          title: (n) =>
            `${n} File${n != 1 ? 's' : ''} Missing Proper Cache Headers`,
          description: `Add a Cache-Control or Expires header to prevent browsers from having to re-download files.`,
          ignorable: true
        },
        placeholder_asset: {
          title: (n) =>
            `Replace ${n} Placeholder Image${n != 1 ? 's' : ''}`,
          description: `These images were part of the default template when the page was created. Consider replacing them with something else.`,
          ignorable: true
        }
      }
      return _.orderBy(
        this.asset_issues
          .map((i) => ({
            ...i,
            ...content[i.id.replace('asset_', '')],
            is_expanded: this.expanded == i.id
          }))
          .filter(e => e.description)
        , 'is_expanded', 'desc')
    }
  },

  watch: {},

  methods: {
    toggleIgnore(issue) {
      this.$emit('ignore', issue.id, issue.ignored)
      _zyppy.track(`Issue ${issue.ignored ? 'Un-' : ''}Muted`, {
        name: issue.id,
        page_id: this.page.id,
        type: 'links'
      })
    }
  }
}
</script>